import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import MuiTypography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import PerfectScrollbar from 'react-perfect-scrollbar';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import MuiSelect from '@material-ui/core/Select';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const {children, classes, onClose, ...other} = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const Typography = withStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(1),
  },
}))(MuiTypography);

const Select = withStyles((theme) => ({
  root: {
    padding: '12px 14px',
  },
}))(MuiSelect);

export default function CustomizedDialogs() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [tahunSPPT, setTahunSPPT] = React.useState('2021');

  const handleChangeTahun = (event) => {
    setTahunSPPT(event.target.value);
  };

  return (
    <div>
      <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        Open dialog
      </Button>
      <Dialog aria-labelledby="customized-dialog-title" open={open} fullWidth={true} maxWidth="lg">
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Informasi Details
        </DialogTitle>
        <PerfectScrollbar>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <Grid container spacing={1}>
                  <Grid item xs={12} style={{backgroundColor: '#ECF0F1'}}>
                    Objek Pajak
                  </Grid>
                  {/*  NOP  */}
                  <Grid item xs={12} md={12} lg={12} style={{fontWeight: 'bold'}}>
                    62.02.080.001.011.0004.0
                  </Grid>

                  {/*  Alamat  */}
                  <Grid item xs={5} md={5} lg={5}>
                    Alamat
                  </Grid>
                  <Grid item xs={7} md={7} lg={7}>
                    : JL SUKA BUMI
                  </Grid>

                  {/*  Blok/Kav/No.  */}
                  <Grid item xs={5} md={5} lg={5}>
                    Blok / Kav / No.
                  </Grid>
                  <Grid item xs={7} md={7} lg={7}>
                    : 007
                  </Grid>

                  {/*  RT/RW  */}
                  <Grid item xs={5} md={5} lg={5}>
                    RT / RW
                  </Grid>
                  <Grid item xs={7} md={7} lg={7}>
                    : 008 / 000
                  </Grid>

                  {/*  Kode ZNT  */}
                  <Grid item xs={5} md={5} lg={5}>
                    Kode ZNT
                  </Grid>
                  <Grid item xs={7} md={7} lg={7}>
                    : AS
                  </Grid>

                  {/*  Jenis Bumi  */}
                  <Grid item xs={5} md={5} lg={5}>
                    Jenis Bumi
                  </Grid>
                  <Grid item xs={7} md={7} lg={7}>
                    : TANAH+BANGUNAN
                  </Grid>

                  {/*  Jumlah Bangunan  */}
                  <Grid item xs={5} md={5} lg={5}>
                    Jumlah Bangunan
                  </Grid>
                  <Grid item xs={7} md={7} lg={7}>
                    : 1
                  </Grid>

                  <Grid item xs={12} />
                  <Grid item xs={12} />
                  <Grid item xs={12} />

                  <Grid item xs={12} style={{backgroundColor: '#ECF0F1'}}>
                    Subjek Pajak
                  </Grid>

                  {/*  Wajib Pajak  */}
                  <Grid item xs={5} md={5} lg={5}>
                    Wajib Pajak
                  </Grid>
                  <Grid item xs={7} md={7} lg={7}>
                    : SUJIONO
                  </Grid>

                  {/*  Alamat  */}
                  <Grid item xs={5} md={5} lg={5}>
                    Alamat
                  </Grid>
                  <Grid item xs={7} md={7} lg={7}>
                    : JL SUKA BUMI
                  </Grid>

                  {/*  Blok/Kav/No.  */}
                  <Grid item xs={5} md={5} lg={5}>
                    Blok / Kav / No.
                  </Grid>
                  <Grid item xs={7} md={7} lg={7}>
                    : 007
                  </Grid>

                  {/*  RT/RW  */}
                  <Grid item xs={5} md={5} lg={5}>
                    RT / RW
                  </Grid>
                  <Grid item xs={7} md={7} lg={7}>
                    : 008 / 000
                  </Grid>

                  {/*  Kelurahan  */}
                  <Grid item xs={5} md={5} lg={5}>
                    Kelurahan
                  </Grid>
                  <Grid item xs={7} md={7} lg={7}>
                    : BAAMANG HILIR
                  </Grid>

                  {/*  Kabupaten  */}
                  <Grid item xs={5} md={5} lg={5}>
                    Kabupaten
                  </Grid>
                  <Grid item xs={7} md={7} lg={7}>
                    : KOTAWARINGIN TIMUR
                  </Grid>

                  {/*  Status Pekerjaan  */}
                  <Grid item xs={5} md={5} lg={5}>
                    Status Pekerjaan
                  </Grid>
                  <Grid item xs={7} md={7} lg={7}>
                    : TNI
                  </Grid>

                  {/*  Status Wajib Pajak  */}
                  <Grid item xs={5} md={5} lg={5}>
                    Status WP
                  </Grid>
                  <Grid item xs={7} md={7} lg={7}>
                    : PEMILIK
                  </Grid>

                  {/*  Kode Pos  */}
                  <Grid item xs={5} md={5} lg={5}>
                    Kode Pos
                  </Grid>
                  <Grid item xs={7} md={7} lg={7}>
                    : 34521
                  </Grid>

                  {/*  No.Telepon  */}
                  <Grid item xs={5} md={5} lg={5}>
                    No.Telepon
                  </Grid>
                  <Grid item xs={7} md={7} lg={7}>
                    : 0897123123
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} md={8} lg={8}>
                <Grid container spacing={1}>
                  <Grid item xs={12} style={{backgroundColor: '#ECF0F1'}}>
                    SPPT
                  </Grid>
                  {/*  Tahun SPPT  */}
                  <Grid item xs={12} style={{marginTop: 15, marginBottom: 5}}>
                    <FormControl variant="outlined" style={{minWidth: 160}}>
                      <InputLabel>Tahun SPPT</InputLabel>
                      <Select value={tahunSPPT} onChange={handleChangeTahun} label="Tahun SPPT">
                        <MenuItem value={2021}>2021</MenuItem>
                        <MenuItem value={2020}>2020</MenuItem>
                        <MenuItem value={2019}>2019</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  {/*  Wajib Pajak  */}
                  <Grid item xs={3}>
                    Wajib Pajak
                  </Grid>
                  <Grid item xs={3}>
                    : SUJIONO
                  </Grid>

                  {/*  Tanggal Jatuh Tempo SPPT  */}
                  <Grid item xs={3}>
                    Tanggal Jatuh Tempo
                  </Grid>
                  <Grid item xs={3}>
                    : 1 Juni 2021
                  </Grid>

                  {/*  Alamat  */}
                  <Grid item xs={3}>
                    Alamat
                  </Grid>
                  <Grid item xs={3}>
                    : JL SUKA BUMI
                  </Grid>

                  {/*  Status Pembayaran SPPT  */}
                  <Grid item xs={3}>
                    Status Pembayaran
                  </Grid>
                  <Grid item xs={3}>
                    : Lunas
                  </Grid>

                  {/*  RT/RW  */}
                  <Grid item xs={3}>
                    RT / RW
                  </Grid>
                  <Grid item xs={3}>
                    : 008 / 000
                  </Grid>

                  {/*  Tanggal Pembayaran SPPT  */}
                  <Grid item xs={3}>
                    Tanggal Pembayaran
                  </Grid>
                  <Grid item xs={3}>
                    : 1 Juni 2021
                  </Grid>

                  {/*  Kelurahan  */}
                  <Grid item xs={3}>
                    Kelurahan
                  </Grid>
                  <Grid item xs={3}>
                    : BAAMANG HILIR
                  </Grid>

                  {/*  Tempat Pembayaran SPPT  */}
                  <Grid item xs={3}>
                    Tempat Pembayaran
                  </Grid>
                  <Grid item xs={3}>
                    : BANK DKI
                  </Grid>

                  {/*  Kabupaten  */}
                  <Grid item xs={3}>
                    Kabupaten
                  </Grid>
                  <Grid item xs={9}>
                    : KOTAWARINGIN TIMUR
                  </Grid>

                  <Grid item xs={12}>
                    <Divider style={{marginTop: 10, marginBottom: 10}} />
                  </Grid>

                  {/*  Header SPPT  */}
                  <Grid item xs={2} />
                  <Grid item xs={2} style={{textAlign: 'center'}}>
                    Kelas
                  </Grid>
                  <Grid item xs={2} style={{textAlign: 'center'}}>
                    Luas
                  </Grid>
                  <Grid item xs={2} style={{textAlign: 'center'}}>
                    NJOP M<sup>2</sup>
                  </Grid>
                  <Grid item xs={4} style={{textAlign: 'center'}}>
                    Jumlah NJOP
                  </Grid>

                  {/*  Details Bumi SPPT  */}
                  <Grid item xs={2}>
                    Bumi
                  </Grid>
                  <Grid item xs={2} style={{textAlign: 'center'}}>
                    0A1 / 1999
                  </Grid>
                  <Grid item xs={2} style={{textAlign: 'center'}}>
                    192
                  </Grid>
                  <Grid item xs={2} style={{textAlign: 'center'}}>
                    Rp. 345.000
                  </Grid>
                  <Grid item xs={4} style={{paddingLeft: 50}}>
                    Rp. 124.198.000
                  </Grid>

                  {/*  Details Bangunan SPPT  */}
                  <Grid item xs={2}>
                    Bangunan
                  </Grid>
                  <Grid item xs={2} style={{textAlign: 'center'}}>
                    0B1 / 1979
                  </Grid>
                  <Grid item xs={2} style={{textAlign: 'center'}}>
                    123
                  </Grid>
                  <Grid item xs={2} style={{textAlign: 'center'}}>
                    Rp. 1.000
                  </Grid>
                  <Grid item xs={4} style={{paddingLeft: 50}}>
                    Rp. 1.198.000
                  </Grid>

                  <Grid item xs={8} />
                  <Grid item xs={4}>
                    <Divider style={{marginTop: 10, marginBottom: 10}} />
                  </Grid>

                  {/*  NJOP SPPT  */}
                  <Grid item xs={8}>
                    Total NJOP
                  </Grid>
                  <Grid item xs={4} style={{paddingLeft: 50}}>
                    Rp. 1.198.000
                  </Grid>

                  {/*  NJOPTKP SPPT  */}
                  <Grid item xs={8}>
                    NJOPTKP
                  </Grid>
                  <Grid item xs={4} style={{paddingLeft: 50}}>
                    Rp. 0
                  </Grid>

                  {/*  PBB TERUTANG SPPT  */}
                  <Grid item xs={8}>
                    PBB Terhutang
                  </Grid>
                  <Grid item xs={4} style={{paddingLeft: 50}}>
                    Rp. 1.198.000
                  </Grid>

                  {/*  FAKTOR PENGURANG SPPT  */}
                  <Grid item xs={8}>
                    Faktor Pengurang
                  </Grid>
                  <Grid item xs={4} style={{paddingLeft: 50}}>
                    Rp. 0
                  </Grid>

                  {/*  PBB YANG HARUS DIBAYAR SPPT  */}
                  <Grid item xs={8}>
                    PBB Yang Harus Dibayar
                  </Grid>
                  <Grid item xs={4} style={{paddingLeft: 50}}>
                    Rp. 1.198.000
                  </Grid>

                  {/*  Denda SPPT  */}
                  <Grid item xs={8}>
                    Denda
                  </Grid>
                  <Grid item xs={4} style={{paddingLeft: 50}}>
                    Rp. 0
                  </Grid>

                  {/*  PBB Yang Telah Dibayar SPPT  */}
                  <Grid item xs={8}>
                    PBB Yang Telah Dibayar
                  </Grid>
                  <Grid item xs={4} style={{paddingLeft: 50}}>
                    Rp. 1.198.000
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
        </PerfectScrollbar>
      </Dialog>
    </div>
  );
}
